import { render, staticRenderFns } from "./DayOffWorking.vue?vue&type=template&id=5a237c08"
import script from "./DayOffWorking.vue?vue&type=script&lang=js"
export * from "./DayOffWorking.vue?vue&type=script&lang=js"
import style0 from "./DayOffWorking.vue?vue&type=style&index=0&id=5a237c08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports